var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_436_",
    d: "M23.3 18V19.875C23.3 20.9093 22.4585 21.75 21.425 21.75H5.30005C3.64555 21.75 2.30005 20.4045 2.30005 18.75C2.30005 18.75 2.30005 6.01125 2.30005 6C2.30005 4.3455 3.64555 3 5.30005 3H19.175C19.7968 3 20.3 3.504 20.3 4.125C20.3 4.746 19.7968 5.25 19.175 5.25H5.30005C4.8868 5.25 4.55005 5.586 4.55005 6C4.55005 6.414 4.8868 6.75 5.30005 6.75H21.425C22.4585 6.75 23.3 7.59075 23.3 8.625V10.5H19.55C17.4823 10.5 15.8 12.1823 15.8 14.25C15.8 16.3177 17.4823 18 19.55 18H23.3Z",
    fill: "url(#paint0_linear_1404_14212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_438_",
    d: "M23.3 12V16.5H19.55C18.3073 16.5 17.3 15.4927 17.3 14.25C17.3 13.0073 18.3073 12 19.55 12H23.3Z",
    fill: "url(#paint1_linear_1404_14212)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1404_14212",
    x1: 12.8,
    y1: 3,
    x2: 12.8,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1404_14212",
    x1: 20.3,
    y1: 12,
    x2: 20.3,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.ed7d6690b092b4111493a6827ca030b2.svg";
export { ForwardRef as ReactComponent };